// ============================================================================
// Indonesian Administrative Map — Kota/Kabupaten → Provinsi
// ============================================================================
// Untuk Composite Scoring spec 3.2: "Kota sama = 1.0, provinsi sama = 0.5".
// Dipakai sebagai fallback ketika nama kota tidak ditemukan di corpus tapi
// provinsi-nya muncul (kandidat masih di wilayah administratif yang sama).
//
// Cakupan: 38 provinsi Indonesia + 500+ kabupaten/kota.
// Internal data dan output semua LOWERCASE untuk konsistensi dgn corpus
// matching yang lowercased di compositeScore.js / containsCi().
//
// Aliases per provinsi (e.g. KALTIM, JABAR, NTT) penting untuk corpus
// matching karena bio sosmed sering pakai singkatan, bukan nama lengkap.
// ============================================================================

const PROVINCE_DATA = {
  'aceh': {
    aliases: ['aceh', 'nanggroe aceh darussalam', 'nad'],
    cities: ['banda aceh', 'sabang', 'langsa', 'lhokseumawe', 'subulussalam',
             'aceh barat', 'aceh barat daya', 'aceh besar', 'aceh jaya',
             'aceh selatan', 'aceh singkil', 'aceh tamiang', 'aceh tengah',
             'aceh tenggara', 'aceh timur', 'aceh utara', 'bener meriah',
             'bireuen', 'gayo lues', 'nagan raya', 'pidie', 'pidie jaya', 'simeulue'],
  },
  'sumatera utara': {
    aliases: ['sumatera utara', 'sumut', 'north sumatra'],
    cities: ['medan', 'binjai', 'tebing tinggi', 'pematangsiantar', 'tanjungbalai',
             'sibolga', 'padangsidimpuan', 'gunungsitoli', 'asahan', 'batu bara',
             'dairi', 'deli serdang', 'humbang hasundutan', 'karo', 'labuhanbatu',
             'langkat', 'mandailing natal', 'nias', 'padang lawas', 'pakpak bharat',
             'samosir', 'serdang bedagai', 'simalungun', 'tapanuli selatan',
             'tapanuli tengah', 'tapanuli utara', 'toba'],
  },
  'sumatera barat': {
    aliases: ['sumatera barat', 'sumbar', 'west sumatra'],
    cities: ['padang', 'bukittinggi', 'padangpanjang', 'pariaman', 'payakumbuh',
             'sawahlunto', 'solok', 'agam', 'dharmasraya', 'kepulauan mentawai',
             'lima puluh kota', 'padang pariaman', 'pasaman', 'pasaman barat',
             'pesisir selatan', 'sijunjung', 'solok selatan', 'tanah datar'],
  },
  'riau': {
    aliases: ['riau'],
    cities: ['pekanbaru', 'dumai', 'bengkalis', 'indragiri hilir', 'indragiri hulu',
             'kampar', 'kepulauan meranti', 'kuantan singingi', 'pelalawan',
             'rokan hilir', 'rokan hulu', 'siak'],
  },
  'kepulauan riau': {
    aliases: ['kepulauan riau', 'kepri'],
    cities: ['tanjungpinang', 'batam', 'bintan', 'karimun', 'kepulauan anambas',
             'lingga', 'natuna'],
  },
  'jambi': {
    aliases: ['jambi'],
    cities: ['jambi', 'sungai penuh', 'batanghari', 'bungo', 'kerinci', 'merangin',
             'muaro jambi', 'sarolangun', 'tanjung jabung barat', 'tanjung jabung timur',
             'tebo'],
  },
  'sumatera selatan': {
    aliases: ['sumatera selatan', 'sumsel', 'south sumatra'],
    cities: ['palembang', 'lubuklinggau', 'pagar alam', 'prabumulih', 'banyuasin',
             'empat lawang', 'lahat', 'muara enim', 'musi banyuasin', 'musi rawas',
             'musi rawas utara', 'ogan ilir', 'ogan komering ilir', 'ogan komering ulu',
             'ogan komering ulu selatan', 'ogan komering ulu timur', 'pali'],
  },
  'bengkulu': {
    aliases: ['bengkulu'],
    cities: ['bengkulu', 'bengkulu selatan', 'bengkulu tengah', 'bengkulu utara',
             'kaur', 'kepahiang', 'lebong', 'mukomuko', 'rejang lebong', 'seluma'],
  },
  'lampung': {
    aliases: ['lampung'],
    cities: ['bandar lampung', 'metro', 'lampung barat', 'lampung selatan',
             'lampung tengah', 'lampung timur', 'lampung utara', 'mesuji',
             'pesawaran', 'pesisir barat', 'pringsewu', 'tanggamus', 'tulang bawang',
             'tulang bawang barat', 'way kanan'],
  },
  'kepulauan bangka belitung': {
    aliases: ['kepulauan bangka belitung', 'babel', 'bangka belitung'],
    cities: ['pangkalpinang', 'bangka', 'bangka barat', 'bangka selatan',
             'bangka tengah', 'belitung', 'belitung timur'],
  },
  'dki jakarta': {
    aliases: ['dki jakarta', 'jakarta', 'daerah khusus ibukota jakarta'],
    cities: ['jakarta', 'jakarta pusat', 'jakarta utara', 'jakarta barat',
             'jakarta selatan', 'jakarta timur', 'kepulauan seribu'],
  },
  'jawa barat': {
    aliases: ['jawa barat', 'jabar', 'west java'],
    cities: ['bandung', 'bekasi', 'bogor', 'cimahi', 'cirebon', 'depok',
             'sukabumi', 'tasikmalaya', 'banjar', 'bandung barat', 'cianjur',
             'ciamis', 'garut', 'indramayu', 'karawang', 'kuningan', 'majalengka',
             'pangandaran', 'purwakarta', 'subang', 'sumedang'],
  },
  'banten': {
    aliases: ['banten'],
    cities: ['serang', 'cilegon', 'tangerang', 'tangerang selatan', 'lebak',
             'pandeglang'],
  },
  'jawa tengah': {
    aliases: ['jawa tengah', 'jateng', 'central java'],
    cities: ['semarang', 'surakarta', 'solo', 'magelang', 'pekalongan', 'salatiga',
             'tegal', 'banjarnegara', 'banyumas', 'batang', 'blora', 'boyolali',
             'brebes', 'cilacap', 'demak', 'grobogan', 'jepara', 'karanganyar',
             'kebumen', 'kendal', 'klaten', 'kudus', 'pati', 'pemalang', 'purbalingga',
             'purworejo', 'rembang', 'sragen', 'sukoharjo', 'temanggung', 'wonogiri',
             'wonosobo'],
  },
  'di yogyakarta': {
    aliases: ['di yogyakarta', 'yogyakarta', 'diy', 'jogja', 'daerah istimewa yogyakarta'],
    cities: ['yogyakarta', 'bantul', 'gunungkidul', 'gunung kidul', 'kulon progo', 'sleman'],
  },
  'jawa timur': {
    aliases: ['jawa timur', 'jatim', 'east java'],
    cities: ['surabaya', 'malang', 'kediri', 'madiun', 'mojokerto', 'pasuruan',
             'probolinggo', 'batu', 'blitar', 'bangkalan', 'banyuwangi', 'bojonegoro',
             'bondowoso', 'gresik', 'jember', 'jombang', 'lamongan', 'lumajang',
             'magetan', 'nganjuk', 'ngawi', 'pacitan', 'pamekasan', 'ponorogo',
             'sampang', 'sidoarjo', 'situbondo', 'sumenep', 'trenggalek', 'tuban',
             'tulungagung'],
  },
  'bali': {
    aliases: ['bali'],
    cities: ['denpasar', 'badung', 'bangli', 'buleleng', 'gianyar', 'jembrana',
             'karangasem', 'klungkung', 'tabanan'],
  },
  'nusa tenggara barat': {
    aliases: ['nusa tenggara barat', 'ntb', 'west nusa tenggara'],
    cities: ['mataram', 'bima', 'dompu', 'lombok barat', 'lombok tengah',
             'lombok timur', 'lombok utara', 'sumbawa', 'sumbawa barat'],
  },
  'nusa tenggara timur': {
    aliases: ['nusa tenggara timur', 'ntt', 'east nusa tenggara'],
    cities: ['kupang', 'alor', 'belu', 'ende', 'flores timur', 'lembata',
             'malaka', 'manggarai', 'manggarai barat', 'manggarai timur', 'nagekeo',
             'ngada', 'rote ndao', 'sabu raijua', 'sikka', 'sumba barat',
             'sumba barat daya', 'sumba tengah', 'sumba timur', 'timor tengah selatan',
             'timor tengah utara'],
  },
  'kalimantan barat': {
    aliases: ['kalimantan barat', 'kalbar', 'west kalimantan'],
    cities: ['pontianak', 'singkawang', 'bengkayang', 'kapuas hulu', 'kayong utara',
             'ketapang', 'kubu raya', 'landak', 'melawi', 'mempawah', 'sambas',
             'sanggau', 'sekadau', 'sintang'],
  },
  'kalimantan tengah': {
    aliases: ['kalimantan tengah', 'kalteng', 'central kalimantan'],
    cities: ['palangkaraya', 'palangka raya', 'barito selatan', 'barito timur',
             'barito utara', 'gunung mas', 'kapuas', 'katingan', 'kotawaringin barat',
             'kotawaringin timur', 'lamandau', 'murung raya', 'pulang pisau',
             'seruyan', 'sukamara'],
  },
  'kalimantan selatan': {
    aliases: ['kalimantan selatan', 'kalsel', 'south kalimantan'],
    cities: ['banjarmasin', 'banjarbaru', 'balangan', 'banjar', 'barito kuala',
             'hulu sungai selatan', 'hulu sungai tengah', 'hulu sungai utara',
             'kotabaru', 'tabalong', 'tanah bumbu', 'tanah laut', 'tapin'],
  },
  'kalimantan timur': {
    aliases: ['kalimantan timur', 'kaltim', 'east kalimantan'],
    cities: ['samarinda', 'balikpapan', 'bontang', 'kutai kartanegara', 'kukar',
             'kutai barat', 'kubar', 'kutai timur', 'kutim', 'berau', 'paser',
             'penajam paser utara', 'ppu', 'mahakam ulu', 'mahulu', 'ikn', 'nusantara'],
  },
  'kalimantan utara': {
    aliases: ['kalimantan utara', 'kaltara', 'north kalimantan'],
    cities: ['tanjung selor', 'tarakan', 'bulungan', 'malinau', 'nunukan',
             'tana tidung'],
  },
  'sulawesi utara': {
    aliases: ['sulawesi utara', 'sulut', 'north sulawesi'],
    cities: ['manado', 'bitung', 'kotamobagu', 'tomohon', 'bolaang mongondow',
             'bolaang mongondow selatan', 'bolaang mongondow timur',
             'bolaang mongondow utara', 'kepulauan sangihe',
             'kepulauan siau tagulandang biaro', 'kepulauan talaud', 'minahasa',
             'minahasa selatan', 'minahasa tenggara', 'minahasa utara'],
  },
  'gorontalo': {
    aliases: ['gorontalo'],
    cities: ['gorontalo', 'boalemo', 'bone bolango', 'gorontalo utara', 'pohuwato'],
  },
  'sulawesi tengah': {
    aliases: ['sulawesi tengah', 'sulteng', 'central sulawesi'],
    cities: ['palu', 'banggai', 'banggai kepulauan', 'banggai laut', 'buol',
             'donggala', 'morowali', 'morowali utara', 'parigi moutong', 'poso',
             'sigi', 'tojo una-una', 'toli-toli'],
  },
  'sulawesi barat': {
    aliases: ['sulawesi barat', 'sulbar', 'west sulawesi'],
    cities: ['mamuju', 'majene', 'mamasa', 'mamuju tengah', 'pasangkayu', 'polewali mandar'],
  },
  'sulawesi selatan': {
    aliases: ['sulawesi selatan', 'sulsel', 'south sulawesi'],
    cities: ['makassar', 'palopo', 'parepare', 'bantaeng', 'barru', 'bone',
             'bulukumba', 'enrekang', 'gowa', 'jeneponto', 'kepulauan selayar',
             'luwu', 'luwu timur', 'luwu utara', 'maros', 'pangkajene dan kepulauan',
             'pinrang', 'sidenreng rappang', 'sinjai', 'soppeng', 'takalar',
             'tana toraja', 'toraja utara', 'wajo'],
  },
  'sulawesi tenggara': {
    aliases: ['sulawesi tenggara', 'sultra', 'southeast sulawesi'],
    cities: ['kendari', 'baubau', 'bombana', 'buton', 'buton selatan', 'buton tengah',
             'buton utara', 'kolaka', 'kolaka timur', 'kolaka utara', 'konawe',
             'konawe kepulauan', 'konawe selatan', 'konawe utara', 'muna', 'muna barat',
             'wakatobi'],
  },
  'maluku': {
    aliases: ['maluku'],
    cities: ['ambon', 'tual', 'buru', 'buru selatan', 'kepulauan aru',
             'maluku barat daya', 'maluku tengah', 'maluku tenggara',
             'kepulauan tanimbar', 'seram bagian barat', 'seram bagian timur'],
  },
  'maluku utara': {
    aliases: ['maluku utara', 'malut', 'north maluku'],
    cities: ['sofifi', 'ternate', 'tidore kepulauan', 'halmahera barat',
             'halmahera selatan', 'halmahera tengah', 'halmahera timur',
             'halmahera utara', 'kepulauan sula', 'pulau morotai', 'pulau taliabu'],
  },
  'papua': {
    aliases: ['papua'],
    cities: ['jayapura', 'biak numfor', 'keerom', 'kepulauan yapen',
             'mamberamo raya', 'sarmi', 'supiori', 'waropen'],
  },
  'papua barat': {
    aliases: ['papua barat', 'west papua'],
    cities: ['manokwari', 'fakfak', 'kaimana', 'manokwari selatan',
             'pegunungan arfak', 'teluk bintuni', 'teluk wondama'],
  },
  'papua barat daya': {
    aliases: ['papua barat daya', 'southwest papua'],
    cities: ['sorong', 'maybrat', 'raja ampat', 'sorong selatan', 'tambrauw'],
  },
  'papua selatan': {
    aliases: ['papua selatan', 'south papua'],
    cities: ['merauke', 'asmat', 'boven digoel', 'mappi'],
  },
  'papua tengah': {
    aliases: ['papua tengah', 'central papua'],
    cities: ['nabire', 'deiyai', 'dogiyai', 'intan jaya', 'mimika', 'paniai',
             'puncak', 'puncak jaya'],
  },
  'papua pegunungan': {
    aliases: ['papua pegunungan', 'highland papua'],
    cities: ['jayawijaya', 'lanny jaya', 'mamberamo tengah', 'nduga',
             'pegunungan bintang', 'tolikara', 'yahukimo', 'yalimo'],
  },
};

// Reverse index city → province, dan flat alias index untuk fast lookup.
const _cityToProvince = (() => {
  const m = new Map();
  for (const [prov, data] of Object.entries(PROVINCE_DATA)) {
    for (const city of data.cities) m.set(city, prov);
  }
  return m;
})();

const _provinceFromAlias = (() => {
  const m = new Map();
  for (const [prov, data] of Object.entries(PROVINCE_DATA)) {
    for (const alias of data.aliases) m.set(alias, prov);
    m.set(prov, prov);
  }
  return m;
})();

/**
 * Normalize Indonesian city/region name. Strip prefix "kota"/"kabupaten"/"kab.",
 * lowercase, trim. Contoh: "Kabupaten Kutai Kartanegara" → "kutai kartanegara".
 */
function normalize(s) {
  if (!s) return '';
  return String(s).toLowerCase().trim()
    .replace(/^(kota|kab\.?|kabupaten)\s+/i, '')
    .trim();
}

/**
 * Lookup provinsi name (lowercase) dari nama kota/kabupaten ATAU nama provinsi/alias.
 * Return null kalau tidak terdaftar.
 */
export function lookupProvinsi(input) {
  const n = normalize(input);
  if (!n) return null;
  return _cityToProvince.get(n) || _provinceFromAlias.get(n) || null;
}

/**
 * Cek apakah corpus mengandung nama provinsi (atau alias-nya).
 * Returns true kalau "kalimantan timur", "kaltim", atau "east kalimantan" ditemukan
 * untuk provinsi 'kalimantan timur'.
 */
export function corpusMentionsProvince(corpus, provinceName) {
  if (!corpus || !provinceName) return false;
  const c = String(corpus).toLowerCase();
  const data = PROVINCE_DATA[provinceName.toLowerCase()];
  if (!data) return false;
  return data.aliases.some(a => c.includes(a));
}

/**
 * Cek apakah corpus mengandung kota lain dari provinsi yang sama dgn subjek.
 * Demo case: subjek Kutai Kartanegara, corpus "domisili Samarinda" → true (Kaltim).
 */
export function corpusMentionsSiblingCity(corpus, subjectProvince) {
  if (!corpus || !subjectProvince) return false;
  const c = String(corpus).toLowerCase();
  const data = PROVINCE_DATA[subjectProvince.toLowerCase()];
  if (!data) return false;
  return data.cities.some(city => c.includes(city));
}

/**
 * Untuk audit/debug — daftar semua kota di provinsi tertentu.
 */
export function getCitiesInProvince(provinceName) {
  if (!provinceName) return [];
  return PROVINCE_DATA[provinceName.toLowerCase()]?.cities || [];
}

export { PROVINCE_DATA };
